export const hashPath = (path: string) =>
  path.startsWith('#') ? path : `#${path}`;

export const fillPath = (path: string, ...params: (string | number)[]) =>
  params.reduce<string>(
    (route, param) => route.replace(/:\w+/, String(param)),
    path,
  );

export const laxPath = (path: string): string =>
  path.length === 0 ? '*' : `${path}/*`;

export const relativePath = (path: string, rootPath: string) => {
  if (path === rootPath) return '';
  const parentPath = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;
  return path.startsWith(parentPath) ? path.slice(parentPath.length) : path;
};

export const relativeLaxPath = (path: string, rootPath: string) =>
  laxPath(relativePath(path, rootPath));
